import { render, staticRenderFns } from "./UrlsSlidingModal.vue?vue&type=template&id=5965e126&scoped=true&"
import script from "./UrlsSlidingModal.vue?vue&type=script&lang=js&"
export * from "./UrlsSlidingModal.vue?vue&type=script&lang=js&"
import style0 from "./UrlsSlidingModal.vue?vue&type=style&index=0&id=5965e126&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5965e126",
  null
  
)

export default component.exports